{
    "NAME": "TelModuleStatusListLanguage",
    "TelModuleStatusList_Title": "Status van de telefoonmodule",
    "TelModuleStatusList_Column_TelSys": "Telefoonserver",
    "TelModuleStatusList_Column_ClassName": "Klasnaam",
    "TelModuleStatusList_Column_Type": "Type",
    "TelModuleStatusList_Column_Version": "Versie",
    "TelModuleStatusList_Column_Status": "Status",
    "TelModuleStatusList_Column_LastError": "Laatste fout",
    "TelModuleStatusList_Column_LastErrorDateTime": "Datum\/tijd van de laatste fout",
    "TelModuleStatusList_Empty": "Er zijn geen statusitems voor de telefoonmodule beschikbaar."
}